import React from 'react';
import { Route as CustomRoute, RouteProps as CustomRouteProps } from 'react-router-dom';
import { useAuth } from '@domain/auth/auth.hook';
import AppChrome from '@components/app.chrome/app.chrome';
import ErrorBoundary from '@components/error/error.boundary';
import SignIn from '@screens/auth/sign.in';

interface RouteProps extends CustomRouteProps {
  isPublic?: boolean;
  hideAppChrome?: boolean;
  pageTitle?: string;
  component: React.ComponentType;
}

const RouteWrapper = ({ isPublic = false, hideAppChrome = false, pageTitle = '', component: Component, ...rest }: RouteProps) => {
  const { user } = useAuth();

  function routeRender() {
    if (!isPublic && !user) return <SignIn />;

    if (isPublic || hideAppChrome) return <Component />;

    return (
      <AppChrome pageTitle={pageTitle}>
        <ErrorBoundary>
          <Component />
        </ErrorBoundary>
      </AppChrome>
    );
  }

  return <CustomRoute {...rest} render={routeRender} />;
};

export default RouteWrapper;
